import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { SentryService } from './sentry.service';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor = (req: any, next: any) => {
  const sentryService = inject(SentryService);
  
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Capture HTTP errors in Sentry
      if (error.status >= 400) {
        sentryService.captureException(error, {
          url: req.url,
          method: req.method,
          status: error.status,
          statusText: error.statusText,
          headers: req.headers,
          body: req.body
        });
      }

      return throwError(() => error);
    })
  );
}; 